import { useState } from 'react';
import { TDeleteData, TResendInviteData } from '../members.types';
import { notification } from 'antd';
import { cacheDeleteMember, decreaseTotalMemberCountInCache } from '../member-handlers';
import { useResendInviteWorkspaceMemberMutation, useRevokeInvitationTokenMutation } from '@/types/generated/graphql';

export const useInvitation = () => {
  const [resendData, setResendData] = useState<TResendInviteData | null>();
  const [revokeData, setRevokeData] = useState<TDeleteData | null>();

  const requestRevokeInvitation = (id: number, name: string) => {
    setRevokeData({ id, name });
  };

  const [revokeInvitation, { loading: revokeInvitationLoading }] = useRevokeInvitationTokenMutation({
    onCompleted: (res) => {
      notification.success({ message: res?.revokeInvitationToken?.message });
      cacheDeleteMember(res?.revokeInvitationToken?.data?.id as number);
      decreaseTotalMemberCountInCache();
      handleCloseModal();
    },
    onError: (error) => {
      notification.error({ message: error.message });
    },
  });

  const [resendIvitation, { loading: resendInvitationLoading }] = useResendInviteWorkspaceMemberMutation({
    onCompleted: (res) => {
      notification.success({ message: res?.resendInviteWorkspaceMember?.message });
      handleCloseModal();
    },
    onError: (error) => {
      notification.error({ message: error.message });
    },
  });

  const requestResendInvitation = (email: string, name: string) => {
    setResendData({ email, name });
  };

  const handleResendInvitation = () => {
    if (!resendData?.email) return;

    return resendIvitation({
      variables: {
        input: {
          email: resendData?.email,
        },
      },
    });
  };

  const handleRevokeInvitation = () => {
    if (!revokeData?.id) return;

    return revokeInvitation({
      variables: {
        userWorkspaceId: revokeData?.id,
      },
    });
  };

  const handleCloseModal = () => {
    setResendData(null);
    setRevokeData(null);
  };
  return {
    resendData,
    requestResendInvitation,
    handleResendInvitation,
    resendInvitationLoading,
    revokeData,
    requestRevokeInvitation,
    handleRevokeInvitation,
    revokeInvitationLoading,
    handleCloseModal,
  };
};
